import React from 'react';

export default function SklepProduktu(props) {
    const sklep = props.sklep;
    return (
        <tr>
            <td>
            <a target="_blank" rel="noreferrer" href={"" + process.env.REACT_APP_PS_SKLEP_SITE + "/sklep/" + sklep.id_sklep + ",prod," + sklep.id_produkt}><h5 className="m-0 p-0"> {sklep.nazwa_sklepu}</h5></a>
            </td>
            <td>
                {sklep.wojewodztwo}
            </td>
            <td>
                {sklep.powiat}
            </td>
            <td>
                {sklep.gmina}
            </td>
            <td>
                {sklep.miejscowosc}
            </td>
        </tr>
    );
}
